// Faint, slow contour lines that echo the hero's sound lines on light sections.
const make = (offset: number) => Array.from({ length: 9 }, (_, i) => {
  const y = 6 + i * 11;
  const a = 6 + ((i + offset) % 3) * 4;
  return `M-50 ${y} C 250 ${y - a}, 450 ${y + a}, 700 ${y} S 1150 ${y - a}, 1450 ${y}`;
});
const SETS = { a: make(0), b: make(1) };

export const AmbientLines = ({ variant = "a" }: { variant?: "a" | "b" }) => (
  <svg aria-hidden className="ambient-lines pointer-events-none absolute -z-10 inset-0 h-full w-full max-md:hidden" viewBox="0 0 1400 100" preserveAspectRatio="none">
    {SETS[variant].map((d, i) => (
      <path key={i} d={d} fill="none" stroke="hsl(var(--hero-ink))" strokeWidth={i % 3 === 0 ? 0.8 : 0.5} vectorEffect="non-scaling-stroke"
        style={{ animationDelay: `${-i * 2.7}s`, animationDuration: `${18 + ((i * 7) % 5) * 4}s` }} />
    ))}
  </svg>
);
